import * as d3 from 'd3';
import { dN_Rect } from './d_rect';
import { drawHinge } from './drawHinge';
import { drawGrills } from './drawGrills';
import { getGlassDesign } from './glassPatternsDefs';


export function drawCasement2(nSections = 5, indexWindow = 1,
    svg, d = 2, initX = 20, initY = 20, frameWidth = 10, doorData = null, top = false, OneSection = false)
  {
    const frameData = doorData?.frameData;
    const finish = doorData?.finish;
  
    // Access type dynamically
    let type = 'type';
    let windowHeight = parseFloat(frameData.windowHeight_d); 
    if (top){
        type = 'typeTop';
        windowHeight = parseFloat(frameData?.uHeight_d || 0); 
    }
    const typeKey = `${type}${indexWindow}`;
    const widthKey = `windowWidth${indexWindow}_d`;
    const shapeKey = `shape${indexWindow}`;
    const shape = frameData?.[shapeKey] || 'rect';

    if (frameData?.[typeKey] === 'Casement2') {
        let windowWidth = parseFloat(frameData[widthKey]);
        //const windowHeight = parseFloat(frameData.windowHeight_d) - 2*d;
        let adjustedWidth = (windowWidth - 2*d  - frameWidth * 2) / 2;
  
        let xOffset = initX ;
        for (let i = 1; i < indexWindow; i++) {
            const key = `windowWidth${i}_d`;
            xOffset += parseFloat(frameData[key] || 0) + 2 * frameWidth + 2*d;
        }
        
      
        const glassType = `glassType${indexWindow}`;
        const glassColor = doorData?.glass?.[glassType].value || 'white';  
        
        if (OneSection){
            xOffset = initX;
            windowWidth = parseFloat(frameData?.uWidth1_d)  - 
            2 * frameWidth - 2*d + parseInt(nSections);
            adjustedWidth = parseFloat(windowWidth)*0.5 -  1* frameWidth - d;// - 2 * frameWidth + d*nSections; //(windowWidth - 2 * frameWidth)*0.5;
        }
        const glassDesign = getGlassDesign(doorData);
        if (shape === 'rect') {
            dN_Rect(svg, d, xOffset , initY, [
                {
                    w: adjustedWidth,
                    h: windowHeight + 2*d - 2*d - 1,
                    color: glassColor || 'lightblue',
                    glassType: doorData?.glass?.glassType1.label,
                    glassDesign: glassDesign,
                    frameWidth,
                    frameColor: finish?.exteriorColor?.value || 'white',
                    lineFrameColor: 'black',
                    lineFrameThickness: 1,
                    outerStrokeColor: 'black',
                    outerStrokeWidth: 1,
                    fullCorners: true
                },
                {
                    w: adjustedWidth,
                    color: glassColor || 'lightblue',
                    glassType: doorData?.glass?.glassType1.label,
                    glassDesign: glassDesign,
                    forceSubFrame: true,
                    fullCorners: true,
                    displayLabel:  false
                }
            ], {
                labelText: `\u00A0✔`,
                subFrame: true,
                labelOptions: {
                    fontSize: 16,
                    fontColor: 'green',
                    fontOpacity: 0.2
                },
                drawFrame: true
            });
        }
        

        drawGrills(svg, indexWindow,
                xOffset , initY, 
                adjustedWidth, windowHeight + 2*d, frameWidth,
                doorData, top);
        drawGrills(svg, indexWindow,
                xOffset + d + adjustedWidth + 2* frameWidth + d, initY, 
                adjustedWidth + 1, windowHeight + 2*d, frameWidth,
                doorData, top);

         drawHinge(svg, xOffset + d, initY, adjustedWidth, windowHeight, frameWidth,                     
                  'Left',  // hingeType: 1 = left, 2 = right
                  'red'); 
         drawHinge(svg, xOffset + d + adjustedWidth + 2* frameWidth + d, initY, adjustedWidth, windowHeight, frameWidth,                     
                  'Right',  // hingeType: 1 = left, 2 = right
                  'red'); 
  
    }
  }//drawCasement2